import * as React from 'react'

import { Pill } from 'sdk/pill/Pill'

import { renderTextWithBold } from 'core/utils'
import type { AboutStoryMilestoneCmsContent } from 'core/services/cms/interfaces'

import classes from './Storyline.module.scss'

interface StorylineProps {
  milestones: AboutStoryMilestoneCmsContent[]
}

export const Storyline: React.FC<StorylineProps> = ({ milestones }) => {
  return (
    <div className={classes.storyline}>
      {/* Desktop Layout */}
      <div className={classes.desktopLayout}>
        {/* Single continuous gradient line */}
        <div className={classes.continuousLine} />

        {milestones.map((milestone, index) => (
          <div key={`${milestone.label}-${index}`} className={classes.milestoneRow}>
            {/* Text on left for even indices */}
            <div className={classes.textLeft}>
              {index % 2 === 0 && (
                <div className={classes.textContent}>
                  {renderTextWithBold(milestone.description, classes.inlineText)}
                </div>
              )}
            </div>

            {/* Pill in center */}
            <div className={classes.centerColumn}>
              <div className={classes.pillContainer}>
                <Pill
                  text={milestone.label}
                  variant={index === milestones.length - 1 ? 'gradientFilled' : 'gradient'}
                  size='md'
                />
              </div>
            </div>

            {/* Text on right for odd indices */}
            <div className={classes.textRight}>
              {index % 2 === 1 && (
                <div className={classes.textContent}>
                  {renderTextWithBold(milestone.description, classes.inlineText)}
                </div>
              )}
            </div>
          </div>
        ))}
      </div>

      {/* Mobile Layout */}
      <div className={classes.mobileLayout}>
        {milestones.map((milestone, index) => (
          <div key={`${milestone.label}-${index}`} className={classes.mobileMilestone}>
            <Pill
              text={`${index + 1}. ${milestone.label}`}
              variant={index === milestones.length - 1 ? 'gradientFilled' : 'gradient'}
              size='md'
            />
            <div className={classes.textContent}>{renderTextWithBold(milestone.description, classes.inlineText)}</div>
          </div>
        ))}
      </div>
    </div>
  )
}
